import { Core } from "@/core/Core";

export default {

  /* Combo groups */

  async getChoiceGroups(context, {inventoryId, augment}) {
    try{
      return await Core.request("GET", `/api/inventory/${inventoryId}/choice_groups`, {augment});
    } catch (e) {
      return null;
    }
  },

  async getChoiceGroup(context, {inventoryId, id}) {
    try{
      return await Core.request("GET", "/api/inventory/" + inventoryId + "/choice_groups/" + id);
    } catch (e) {
      return null;
    }
  },

  async createChoiceGroup(context, {inventoryId, data}) {
    try{
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/choice_groups", data);
    } catch (e) {
      return null;
    }
  },

  async saveChoiceGroup(context, {inventoryId, itemId, data}) {
    try{
      return await Core.request("PUT", "/api/inventory/" + inventoryId + "/choice_groups/" + itemId, data);
    } catch (e) {
      return null;
    }
  },

  async deleteChoiceGroup(context, {inventoryId, itemId}) {
    try {
      return await Core.request("DELETE", "/api/inventory/" + inventoryId + "/choice_groups/" + itemId);
    } catch(e) {
      return null;
    }
  },


}